<mat-dialog-content>
  <h2 mat-dialog-title>Unable to send Review Request!</h2>
  <p>
    This email has failed because the Review Request and/or Contact Us button
    link to a first party My Listings page.
  </p>
  <p>
    Customize your email template to include a My Preferred Sites dynamic
    component or edit the link for the Contact Us button to direct customers to
    your business website or other third party site.
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
